"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var hooks_1 = require("../../hooks");
var ButtonCancel_1 = __importDefault(require("../ButtonCancel"));
var ButtonNew_1 = __importDefault(require("../ButtonNew"));
var CompositeView_1 = __importDefault(require("../CompositeView"));
var MasterDetailView_1 = __importDefault(require("../MasterDetailView"));
var CrudCreate_1 = __importDefault(require("./CrudCreate"));
var CrudDetail_1 = __importDefault(require("./CrudDetail"));
var CrudMaster_1 = __importDefault(require("./CrudMaster"));
var NoItemSelected_1 = __importDefault(require("./NoItemSelected"));
var CrudMasterDetailView = function (props) {
    var getAllItems = props.getAllItems, infinityItems = props.infinityItems, fullItems = props.fullItems, getItem = props.getItem, createItem = props.createItem, updateItem = props.updateItem, deleteItem = props.deleteItem, disableItem = props.disableItem, filterPredicate = props.filterPredicate, filterInfinity = props.filterInfinity, titleExtractor = props.titleExtractor, detailTitleExtractor = props.detailTitleExtractor, descriptionExtractor = props.descriptionExtractor, idExtractor = props.idExtractor, valueActiveExtractor = props.valueActiveExtractor, _a = props.permissions, permissions = _a === void 0 ? {} : _a, disableNotification = props.disableNotification, icon = props.icon, iconDisable = props.iconDisable, colorDisable = props.colorDisable, children = props.children, extraButtons = props.extraButtons, onYReachEnd = props.onYReachEnd, _b = props.loading, loading = _b === void 0 ? false : _b, _c = props.returnNavigation, returnNavigation = _c === void 0 ? false : _c;
    var _d = react_1.useState([]), items = _d[0], setItems = _d[1];
    var _e = react_1.useState(), selectedId = _e[0], setSelectedId = _e[1];
    var _f = hooks_1.useRouter(), pushRoot = _f.pushRoot, rootUrl = _f.rootUrl;
    var handleGetAllMaster = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getAllItems()];
                case 1:
                    resp = _a.sent();
                    if (resp)
                        setItems(resp);
                    return [2];
            }
        });
    }); }, [getAllItems]);
    react_1.useEffect(function () {
        if (returnNavigation && !selectedId && window.location.pathname && window.location.pathname.indexOf('detail') > 0) {
            var itemSelected = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1, 99);
            setSelectedId(itemSelected);
        }
    }, [returnNavigation, selectedId]);
    var handleCreate = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createItem) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, createItem(value)];
                case 2:
                    resp = _a.sent();
                    if (resp) {
                        if (!disableNotification)
                            __1.notification.success('ui.message.api.save.success');
                        handleGetAllMaster();
                        pushRoot();
                    }
                    return [2, resp];
                case 3:
                    err_1 = _a.sent();
                    if (!disableNotification)
                        __1.notification.error(err_1, 'ui.message.api.error.unexpected');
                    return [3, 4];
                case 4: return [2, undefined];
            }
        });
    }); };
    var handleUpdate = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!updateItem) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, updateItem(value)];
                case 2:
                    resp = _a.sent();
                    if (resp) {
                        if (!disableNotification)
                            __1.notification.success('ui.message.api.save.success');
                        handleGetAllMaster();
                    }
                    return [2, resp];
                case 3:
                    err_2 = _a.sent();
                    if (!disableNotification)
                        __1.notification.error(err_2, 'ui.message.api.error.unexpected');
                    return [3, 4];
                case 4: return [2, false];
            }
        });
    }); };
    var handleDelete = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deleteItem) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, deleteItem(value)];
                case 2:
                    resp = _a.sent();
                    if (resp) {
                        if (!disableNotification)
                            __1.notification.success('ui.message.api.delete.success');
                        handleGetAllMaster();
                        pushRoot();
                    }
                    return [2, resp];
                case 3:
                    err_3 = _a.sent();
                    if (!disableNotification)
                        __1.notification.error(err_3, 'ui.message.api.error.unexpected');
                    return [3, 4];
                case 4: return [2, false];
            }
        });
    }); };
    var handleDisable = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!disableItem) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, disableItem(value)];
                case 2:
                    resp = _a.sent();
                    if (resp) {
                        handleGetAllMaster();
                        pushRoot();
                    }
                    return [2, resp];
                case 3:
                    err_4 = _a.sent();
                    if (!disableNotification)
                        __1.notification.error(err_4, 'ui.message.api.error.unexpected');
                    return [3, 4];
                case 4: return [2, false];
            }
        });
    }); };
    react_1.useEffect(function () {
        handleGetAllMaster();
    }, [handleGetAllMaster]);
    var DetailToolbar = react_1.useMemo(function () {
        return createItem ? react_1.default.createElement(ButtonNew_1.default, { linkTo: rootUrl('new'), viewPermission: permissions.create }) : react_1.default.createElement(react_1.default.Fragment, null);
    }, [createItem, rootUrl, permissions.create]);
    return (react_1.default.createElement(MasterDetailView_1.default, { viewPermission: permissions.read, master: react_1.default.createElement(__1.Loading, { loading: loading },
            react_1.default.createElement(CrudMaster_1.default, { icon: icon, iconDisable: iconDisable, colorDisable: colorDisable, selectedId: selectedId, onYReachEnd: onYReachEnd, items: items, infinityItems: infinityItems, titleExtractor: titleExtractor, descriptionExtractor: descriptionExtractor, idExtractor: idExtractor, valueActiveExtractor: valueActiveExtractor, filterPredicate: filterPredicate, filterInfinity: filterInfinity })), detail: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CompositeView_1.default, { toolbar: DetailToolbar, onRender: function () {
                    setSelectedId(undefined);
                } },
                react_1.default.createElement(NoItemSelected_1.default, null)),
            react_1.default.createElement(CompositeView_1.default, { id: "new", viewPermission: permissions.create, toolbar: react_1.default.createElement(ButtonCancel_1.default, { linkTo: rootUrl() }) },
                react_1.default.createElement(CrudCreate_1.default, { onCreate: handleCreate }, children)),
            react_1.default.createElement(CompositeView_1.default, { id: "detail", path: "/:id", viewPermission: permissions.update, toolbar: DetailToolbar, onRender: function (_a) {
                    var params = _a.match.params;
                    setSelectedId(params.id);
                } },
                react_1.default.createElement(CrudDetail_1.default, { selectedId: selectedId, masterItems: infinityItems || items, fullItems: fullItems, getItem: getItem, infinity: !!infinityItems, onUpdate: updateItem ? handleUpdate : undefined, onDelete: deleteItem ? handleDelete : undefined, onDisabled: disableItem ? handleDisable : undefined, valueActiveExtractor: valueActiveExtractor, titleExtractor: detailTitleExtractor || titleExtractor, idExtractor: idExtractor, deletePermissions: permissions.delete, disableNotification: disableNotification, extraButtons: extraButtons || undefined }, children))) }));
};
exports.default = CrudMasterDetailView;
